import { useEffect, useState } from 'react'

/** Cycles through messages every few seconds while active, starting again from the first each time */
export function useRotatingMessage(messages: readonly string[], active: boolean, intervalMs = 3000): string {
  const [index, setIndex] = useState(0)
  const [wasActive, setWasActive] = useState(active)

  // Reset to the first message whenever processing starts or stops
  // (adjusting state during render, as recommended by the React docs)
  if (active !== wasActive) {
    setWasActive(active)
    setIndex(0)
  }

  useEffect(() => {
    if (!active) return
    const interval = setInterval(() => setIndex((i) => (i + 1) % messages.length), intervalMs)
    return () => clearInterval(interval)
  }, [active, messages.length, intervalMs])

  return messages[index]
}
